"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LexicalIndexNameSchema = exports.LexicalIndexName = void 0;
exports.isLexicalIndexName = isLexicalIndexName;
const zod_1 = require("zod");
var LexicalIndexName;
(function (LexicalIndexName) {
    LexicalIndexName["EnglishLexicalIndex"] = "lexical-english";
    LexicalIndexName["StandardLexicalIndex"] = "lexical-standard";
})(LexicalIndexName || (exports.LexicalIndexName = LexicalIndexName = {}));
exports.LexicalIndexNameSchema = zod_1.z.nativeEnum(LexicalIndexName);
function isLexicalIndexName(name) {
    return Object.values(LexicalIndexName).includes(name);
}
//# sourceMappingURL=search-indexes.js.map